import { ExportBox } from '../../event/export/ExportBox';
import {
    loadCandlePage,
    OldFunctionError,
} from '../../event/export/exportClient';
import type { ExportMarket } from '../../event/export/exportTypes';
import { spanBounds } from './searchExport';

export interface SearchExportButtonProps {
    markets: readonly ExportMarket[];
    label?: string;
    tooltip?: string;
}

function isOldFunction(error: unknown): boolean {
    return error instanceof OldFunctionError;
}

export function SearchExportButton({
    markets,
    label,
    tooltip,
}: SearchExportButtonProps) {
    const first = markets[0]?.event;

    return (
        <ExportBox
            eventId={first?.id ?? ''}
            eventSlug={first?.slug ?? ''}
            eventTitle={first?.title ?? ''}
            shownMarkets={markets}
            allMarkets={markets}
            bounds={spanBounds(markets, Date.now())}
            shownRange={null}
            defaultInterval={60}
            loadPage={loadCandlePage}
            isFatal={isOldFunction}
            label={label}
            tooltip={tooltip}
        />
    );
}
